import BaseComponent from "@components/base/BaseComponent/BaseComponent";
import {ContextCart} from "@contexts/ContextCartProvider";

class ComponentCartContextMiddleware extends BaseComponent {

	static contextType = ContextCart;

	eventConsume(actionName, actionObject) {

		if (actionName === 'ContextCartUpdate') {
			this.context.setContextData(actionObject);
		}

	}

	render() {
		return null;
	}
}

export default ComponentCartContextMiddleware;